/* eslint indent: 0 */
import './media_library.main.less';

// we need jquery-ui in this for draggable and droppable elements.
// additionally, we need it because several places use the fileuploader api directly
import 'zoomforth_file_uploader/file-uploader-shim.js';

import { findDOMNode, createPortal } from 'react-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import autobind from 'class-autobind';
import $ from 'jquery';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import noop from 'lodash/noop';
import sortBy from 'lodash/sortBy';
import omit from 'lodash/omit';
import isNil from 'lodash/isNil';

import AddMediaModal from '../views/global.add_media_modal.js';
import FolderZone from '../views/media_library.folder_zone.js';
import ExpandedAsset from './media_library.expanded_asset.jsx';
import InfoPanel from './info_panel_root.jsx';      
import ActionBar from './action_bar.jsx';

import MediaLibraryAsset from 'zoomforth_media_library/models/media_library_asset.js';
import MediaLibraryNavStateWithLocalStorage from 'zoomforth_media_library/models/media_library_nav_state_with_local_storage.js';
import MediaLibraryUploadTracker from 'zoomforth_media_library/models/media_library_upload_tracker.js';
import { getDisplayNameForAssetType } from '../lib/assets.js';
import { ALL_MEDIA_LIBRARY_ASSET_TYPES } from 'zoomforth_media_library/const.js';
import { sendRequestWithPromise } from 'zoomforth_zfutils/xhr_tools.js';

import Tooltip from 'zoomforth_component_lib/tooltip.jsx';

// single and multi are selection contexts, page is the main ML page, and view only
// lets you view just the results of a specific query
const VALID_CALLING_CONTEXTS = ['single', 'multi', 'page', 'view_only'];
const ACTION_BAR_CONTAINER_CLASSNAME = 'action-bar-container';
const DISABLED_MEDIA_TYPES_BANNER_CLASSNAME = 'disabled-media-types-banner';
const EXPANDED_ASSET_CONTAINER_CLASSNAME = 'expanded-asset-container';
const INFO_PANEL_CONTAINER_CLASSNAME = 'info-panel-container';
const FOLDER_ZONE_CONTAINER_CLASSNAME = 'folder-zone-contaienr';


class MediaLibraryMain extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expandedAssetModel: null
    };

    var initialNavState = {
      ...props.initialNavState,
      // Ignore `folder_id`s which dont have a corresponding folder
      // this is probably due to bad URL hash or deleted folder
      folder_id: props.folderCollection.get(props.initialNavState.folder_id) ?
          props.initialNavState.folder_id
        :
          null
    };

    // this is a weird state where we don't want to pass null into the
    // navState. `null` is a valid folder_id since it points to the root
    // folder. when we pass this with the initialNavState, it overwrites
    // anything that was stored in localStorage. we remove this initial setting
    // instead since there is already a fallback setup for `null` folder_id.
    if (isNil(initialNavState.folder_id)) {
      initialNavState = omit(initialNavState, 'folder_id');
    }

    this.navState = new MediaLibraryNavStateWithLocalStorage(initialNavState, {
      enabledMediaTypes: props.enabledMediaTypes
    });

    autobind(this);
  }

  getIsSelectionContext() {
    return this.props.callingContext !== 'page';
  }

  getCallingContext() {
    return this.props.callingContext;
  }

  getNavState() {
    return this.navState;
  }

  componentDidMount() {
    if (this.props.uploader) {

      this.uploadTracker = new MediaLibraryUploadTracker({
        uploader: this.props.uploader,
        // HACK: through some convoluted hackery the folder zone
        // actually references `getSelectionContext` and `getCallingContext`
        // via this parent reference
        parent: this
      });   
    }

    this.renderFolderZone($(this.folderZoneRef));
    this.navState.on('change', ()=> {
      this.forceUpdate();
      this.renderFolderZone($(this.folderZoneRef));
    });
    this.props.onMediaLibReady({ navState:this.navState, folderZoneObject: this.folderZoneObject  });
  }

  componentWillUnmount() {
    this.folderZoneObject.off();
    this.folderZoneObject.remove();
  }

  handleAssetReplace(params, { onSuccess, onError }){
    sendRequestWithPromise({
      url: 'rpc/replace_asset',
      method: 'POST',
      params: params
    })
    .then((response) => {
      // It can take some time for ES to re-index the changes from the replace. To make sure we 
      // fetch the latest data we wait a second before refreshing the folder. Unfortunately this 
      // means that if re-indexing takes more than a second the changes will not be shown in the UI.
      setTimeout(() => {
        this.folderZoneObject.render();
        onSuccess(response);
      }, 1000);
    })
    .catch(() => onError());
  }

  handleClearAssetSelection(){
    this.folderZoneObject.clearSelection();
  }

  showExpandedAsset(assetModel) {
    this.setState({
      expandedAssetModel: assetModel
    });
  }

  closeExpandedAsset() {
    this.setState({
      expandedAssetModel: null
    });
  }

  _bindFolderZoneListeners(folderZoneView) {
    folderZoneView.on({
      'items-selected': (itemViews)=> {
        var itemModels = map(itemViews, 'model');
        if(this.infoPanelRef){
          this.infoPanelRef.setItemModels(itemModels);
        }
        if(itemModels.length && itemModels[0] instanceof MediaLibraryAsset){
          this.props.onAssetsSelect(itemModels);
        } else if(!itemModels.length) {
          this.props.onAssetsSelect([]);
        }
      },
      'expand-asset': (assetModel)=>  {
        this.showExpandedAsset(assetModel);
      }, 
      'close-expanded-asset': () => {
        this.closeExpandedAsset();
      }
    });
  }

  renderFolderZone($el) {
    var me = this;
    if (me.folderZoneObject) {
      me.folderZoneObject.remove();
    }
    me.folderZoneObject = new FolderZone({
      parent: me,
      collection: me.props.folderCollection,
      currentFolder: me.props.folderCollection.get(me.navState.get('folder_id')),
      navState: me.navState,
      uploadTracker: me.uploadTracker
    });
    me._bindFolderZoneListeners(me.folderZoneObject);
    $el.append(me.folderZoneObject.$el);
    me.folderZoneObject.render();
  }

  getExpandedAssetParent() {
    if (this.getIsSelectionContext()){
      return $(findDOMNode(this)).closest('.media-library-modal').get(0);
    } else {
      return $('body').get(0);
    }
  }

  handleAddMediaClick() {
    
    const currentFolderId = this.navState.get('folder_id');

    var addMediaOptions = {
      enabledInputs: ['upload', 'youtube', 'recording', 'presentation', 'html_package'],
      headerText: 'Add assets to your library',
      multiple: true,
      uploader: this.props.uploader,
      recordingStorageContext: {
        type: 'media_library',
        folder_id: currentFolderId
      }
    };
    
    var addMediaModal = new AddMediaModal(addMediaOptions);
  
    addMediaModal.show()
      .done((typeName, results)=> {

        if (typeName == 'assets'){
          // youtube only
          results[0].save({
            parent_folder_id: currentFolderId
          }, {
            silent: true, patch: true
          })
            .done(()=> {

              this.folderZoneObject.addAssetFromModel(results[0]);
            });
        }
        if (typeName == 'upload'){
          // uploading should already be bound correctly, no action action necessary
        }
      });
    
  }

  render() {

    const { 
      callingContext,
      enabledMediaWarningMsg,
      folderCollection,
      shouldWarnAboutEnabledMedia
    } = this.props;

    const navState = this.navState;

    const shouldDisplayDisabledMediaTypesBanner = (
      navState.getHasDisabledMediaTypes() && !navState.getIsSearchingByMediaTypes()
    );

    const { expandedAssetModel } = this.state;

    const currentFolder = folderCollection.get(this.navState.get('folder_id'));

    return (
      <div className={classNames(
        'media-library',
        this.getCallingContext(),
        {
          'info-panel-shown': !this.getIsSelectionContext(),
          'disabled-media-types-banner-visible': shouldDisplayDisabledMediaTypesBanner,
          'has-active-media-type-search': !isEmpty(navState.getMediaTypesSearch())
        }
      )}>
        {
          callingContext !== 'view_only' &&

          <div className={ACTION_BAR_CONTAINER_CLASSNAME}>
            <ActionBar
              navState={navState}
              onAddMediaClick={()=> { this.handleAddMediaClick(); }}
              onFolderAdd={(folder)=> {
                this.props.folderCollection.add(folder);
                window.location.reload(/*
                  this is not recommended,
                  however we are doing some
                  initial state weirdness
                  that I did not want to touch
                */);
              }}
              shouldDeemphasizeUpload={this.shouldDeemphasizeUpload}
            />
          </div>
        }

        {
          shouldDisplayDisabledMediaTypesBanner &&

          <div className={DISABLED_MEDIA_TYPES_BANNER_CLASSNAME}>
            Displaying media of type: {
              sortBy(
                map(this.navState.getEnabledMediaTypes(), getDisplayNameForAssetType)
              ).join(', ')
            }

            {
              shouldWarnAboutEnabledMedia &&
                <Tooltip
                  placement="right"
                  value={enabledMediaWarningMsg}
                />
            } 

          </div>
        }

        <div className={FOLDER_ZONE_CONTAINER_CLASSNAME} ref={ref => this.folderZoneRef = ref}>
          
        </div>

        {
          !this.getIsSelectionContext() &&

          <div className={INFO_PANEL_CONTAINER_CLASSNAME}>
            <InfoPanel
              navState={navState}
              currentFolder={currentFolder}
              onAssetExpand={(assetModel)=> {
                this.showExpandedAsset(assetModel);
              }}
              onAssetReplace={this.handleAssetReplace}
              onClearAssetSelection={this.handleClearAssetSelection}
              ref={ref => this.infoPanelRef = ref}
            />
          </div>

        }
        
        { 
          expandedAssetModel &&
          createPortal(
            <div className={EXPANDED_ASSET_CONTAINER_CLASSNAME}>
              <ExpandedAsset 
                asset={expandedAssetModel}
                isShowingInfoPanel={this.getIsSelectionContext()}
                onClose={()=> {
                  this.closeExpandedAsset();
                }}
              />
            </div>,
            this.getExpandedAssetParent()
          )
        }
      </div>
    );
  }
}

MediaLibraryMain.propTypes = {
  callingContext: PropTypes.oneOf(VALID_CALLING_CONTEXTS).isRequired,
  enabledMediaTypes: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_MEDIA_LIBRARY_ASSET_TYPES)
  ).isRequired,
  enabledMediaWarningMsg: PropTypes.node,
  folderCollection: PropTypes.object.isRequired,
  initialNavState: PropTypes.object,
  shouldDeemphasizeUpload: PropTypes.bool,
  shouldWarnAboutEnabledMedia: PropTypes.bool.isRequired,
  uploader: PropTypes.object,
  onAssetsSelect: PropTypes.func,
  onNavStateReady: PropTypes.func
};

MediaLibraryMain.defaultProps = {
  callingContext: 'page',
  enabledMediaTypes: ALL_MEDIA_LIBRARY_ASSET_TYPES,
  initialNavState: {},
  shouldDeemphasizeUpload: false,
  shouldWarnAboutEnabledMedia: false,
  onAssetsSelect: noop,
  onMediaLibReady: noop
};

export default MediaLibraryMain;
